import { Pager } from './pager.class';
import { UserInfo } from './statics';
var Setup = /** @class */ (function () {
    function Setup() {
    }
    Setup.AddAdminPanel = function () {
        if (!UserInfo.hasSidePanelAccess()) {
            $('[data-admin]').remove();
            return;
        }
        if (!UserInfo.isAdmin()) {
            if (!UserInfo.permissions.includes(1001))
                $('[data-usercontrol]').remove();
        }
        $('.app-sidebar-minify-btn').on('click', function () {
            $('[data-loader]').css('left', $('[data-sidebar]').width());
        });
        $('[data-page]').on("click", function (e) {
            e.preventDefault();
            if (e.currentTarget.dataset.page != undefined) {
                $('[data-admin]').removeClass("active");
                Pager.loadPage(e.currentTarget.dataset.page, true);
            }
        });
        var timer = undefined;
        $('[data-admin]').on('mouseleave', function () {
            if (timer != undefined)
                clearTimeout(timer);
            timer = setTimeout(function () { return $('[data-admin]').removeClass('active'); }, 1000);
        });
        $('[data-admin]').on('mouseenter', function () {
            if (timer != undefined)
                clearTimeout(timer);
        });
        $('[data-show-adminpanel]').on('click', function () {
            var t = $('[data-admin]');
            if (t.hasClass('active')) {
                t.removeClass('active');
            }
            else {
                t.addClass('active');
            }
        });
        //$('[data-admin]').removeClass("active")
    };
    return Setup;
}());
export { Setup };
